//@flow
import { isEmail, isEmpty, isLength } from "validator"
import type { User } from "./types"

export default (values: User) => {
  const errors = {}
  if (!values.email) {
    errors.email = "Cannot be blank"
  } else if (!isEmail(values.email)) {
    errors.email = "Invalid email address"
  }
  if (
    values.password &&
    !isEmpty(values.password) &&
    !isLength(values.password, { min: 6 })
  ) {
    errors.password = `Must be at least 6 characters ${values.id
      ? "or left blank."
      : ""}`
  } else if (values.password && isEmpty(values.password) && values.id) {
    errors.password = "Must be at least 6 characters."
  }
  if (!values.name || isEmpty(values.name)) {
    errors.name = "Cannot be blank"
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/Users/validate.js